import React, { FC } from 'react'
import { QuoteIcon } from '@components/Icons'
import { TestimonialType } from './types'
import {
  TestimonialCardWrapper,
  IconWrapper,
  Quote,
  Author,
  Role,
} from './TestimonialCard.elements'

type Props = TestimonialType

export const TestimonialCard: FC<Props> = ({
  author,
  quote,
  role
}) => {
  return (
    <TestimonialCardWrapper>
      <IconWrapper>
        <QuoteIcon />
      </IconWrapper>
      <Quote>{quote}</Quote>
      <Author>{author}</Author>
      <Role>{role}</Role>
    </TestimonialCardWrapper>
  )
}
